<form
  [formGroup]="searchExerciseForm"
  (ngSubmit)="createPartialWorkoutStep()"
  class="add-exercise-form"
>
  <ion-button class="ion-margin-bottom add-exercise" size="default" shape="round" fill="outline" color="secondary" slot="end" (click)="openExerciseFilterModal()" >

    {{'add.exercise' | translate}}

    <ion-icon slot="end" name="open-outline"></ion-icon>
  </ion-button>
</form>

<ag-grid-angular
  #agGrid
  [suppressCutToClipboard]="true"
  [enableCellEditingOnBackspace]="true"
  [components]="components"
  [defaultColDef]="defaultColDef"
  [animateRows]="true"
  (gridReady)="onGridReady($event)"
  [rowDragManaged]="true"
  [rowData]="workoutSteps"
  [columnDefs]="columnDefs"
  domLayout='autoHeight'
  (rowDragEnd)="rowDragEnd($event)"
>
</ag-grid-angular>

<ion-list class="workout-steps-list">
  <p *ngIf="workoutSteps.length === 0" class="ion-padding-horizontal">
    {{ 'workout.details.no.exercises' | translate }}
  </p>

  <ion-item-sliding *ngFor="let workoutStep of workoutSteps; let index = index" >
    <ion-item class="ion-no-padding">

      <div class="inner-container" *ngIf="workoutStep.exerciseId | exerciseRenderer: algoliaSdkType | async as exercise">
        <me-exercise-video *ngIf="exercise.videos[0] as video" [video]="video"></me-exercise-video>
        <div class="ion-padding-horizontal">
          <h4>
            {{ exercise.name }}
          </h4>
          <ion-note>
            <ng-container *ngIf="weightUnitOfMeasure$ | async as weightUnitOfMeasure">
              <!-- TODO: deprecate workoutStepDisplay and use me-workout-step instead -->
              {{ workoutStep | workoutStepDisplay: weightUnitOfMeasure }}
            </ng-container>

          </ion-note>
        </div>
        <ion-button class="ion-margin ion-margin-horizontal" (click)="openWorkoutStepFormModal(workoutStep)">{{ 'action.update' | translate }}</ion-button>
      </div>
    </ion-item>
    <ion-item-options side="end">
      <ion-item-option color="danger" (click)="deleteWorkoutStep(index)">
        {{ 'action.remove' | translate }}
      </ion-item-option>
    </ion-item-options>

  </ion-item-sliding>
</ion-list>

<ion-modal #workoutStepFormModal class="workout-step-form-modal">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title> {{ 'workout.step.form.title' | translate }} </ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="workoutStepFormModal.dismiss()">
            <ion-icon name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <form [formGroup]="workoutStepForm" (ngSubmit)="onWorkoutStepFormSubmit()" autocomplete="off">


        <app-exercise-search [algoliaSdkType]="anonymous ? 'anonymous' : 'global'" formControlName="exerciseId"></app-exercise-search>

        <ion-item class="ion-margin-top" fill="outline" lines="none">
          <ion-select labelPlacement="floating" [label]="'workout.step.type' | translate" formControlName="type" interface="popover">
            <ion-select-option [value]="null"></ion-select-option>
            <ion-select-option *ngFor="let possisbleWorkoutType of possisbleWorkoutTypes" [value]="possisbleWorkoutType.value">{{ possisbleWorkoutType.label }}
            </ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item fill="outline" class="ion-margin-top" lines="none">
          <ion-input labelPlacement="floating" [label]="'sets.singular' | translate" autocomplete="off" type="number" formControlName="sets"></ion-input>
        </ion-item>
        <me-value-editor formControlName="value" class="ion-margin-top" [valueType]="workoutStepForm.value.type ?? 'repetitions'"></me-value-editor>
        <ion-item fill="outline" class="ion-margin-top" lines="none" *ngIf="weightUnitOfMeasure$ | async as weightUnitOfMeasure">
          <ion-input labelPlacement="floating" [label]="'workout.step.weight' | translate: { unitOfMeasure: weightUnitOfMeasure } " autocomplete="off" type="number" formControlName="weightValue"></ion-input>
        </ion-item>
        <ion-item fill="outline" class="ion-margin-top" lines="none" *ngIf="!anonymous">
          <ion-checkbox formControlName="weightRequired"></ion-checkbox>
          <ion-label class="ion-margin-start">{{ 'weight.required' | translate }}</ion-label>
          <ion-note slot="helper">
            {{'weight.required.message' | translate }}
          </ion-note>
        </ion-item>
        <ion-item fill="outline" class="ion-margin-top" lines="none">
          <ion-input labelPlacement="floating" [label]="'workout.step.break' | translate" autocomplete="off" type="number" formControlName="break"></ion-input>
        </ion-item>
        <ion-item fill="outline" class="ion-margin-top" lines="none">
          <ion-input labelPlacement="floating" [label]="'notes' | translate" autocomplete="off" type="text" formControlName="notes"></ion-input>
        </ion-item>
        <ion-item fill="outline" class="ion-margin-top" lines="none">
          <ion-select labelPlacement="floating" [label]="'super.sets' | translate" formControlName="superSet" interface="popover">
            <ion-select-option [value]="null"></ion-select-option>
            <ion-select-option *ngFor="let superSet of possibleSuperSets" [value]="superSet">{{ superSet }}
            </ion-select-option>
          </ion-select>
        </ion-item>

        <div *ngIf="!anonymous" formGroupName="customFields">
          <ng-container *ngFor="let customField of workoutCustomFields$ | async">
            <me-custom-field class="ion-margin-top" [formControlName]="customField.id" [customField]="customField"></me-custom-field>
          </ng-container>
        </div>


        <button type="submit" hidden></button>
      </form>
    </ion-content>

    <ion-footer class="ion-padding buttons-container">
      <ion-row class="ion-justify-content-end">
        <ion-button fill="outline" class="ion-margin-end" (click)="workoutStepFormModal.dismiss()">{{'action.cancel' | translate}}</ion-button>
        <ion-button color="secondary" [disabled]="workoutStepForm.invalid" (click)="onWorkoutStepFormSubmit()">{{'action.update' | translate}}</ion-button>
      </ion-row>
    </ion-footer>
  </ng-template>
</ion-modal>
